import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { JyExtendService } from '../../../../routes/workflow/new-flow/newFlow.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowseService } from '@shared/components/browse/browse.service';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styles: []
})
export class ProcessComponent implements BrowseComponent, OnInit {
  static componentName='ProcessComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  pagination: Pagination = new Pagination();
  haveDone : any = {};
  data:any = [];
  pageNum = 0;
  pageSize = 10;
  tableBtnSize = "small";
  allChecked = false;
  constructor(
    private commonsService: CommonsService,
    private modalService: NzModalService,
    private JyExtendService:JyExtendService
  ) {
    var workflowQuery={firstResult:0,maxResult:10,nodeType:"1,2"};
    this.pagination.getData = function (params: HttpParams): Observable<any> {
      return JyExtendService.getHavedone(workflowQuery);
    }
  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.getData();
    this.visible = true;
  }

  resetGetData(){
    this.haveDone = {};
    this.getData();
  }


  getData() {
    var workflowQuery={firstResult:this.pageNum,maxResult:this.pageSize,requestId:this.haveDone.inputId,nodeType:"1,2",title:this.haveDone.title};
    // this.haveDone = {};
    this.JyExtendService.getHavedone(workflowQuery).subscribe((data)=>{
      data.content.forEach(v=>{
        v.checked = false;
      })
      this.data = data.content;
      this.haveDone.allBackNum = data.totalCount;
    })
  }

  reset(){
    this.haveDone.inputId = "";
    this.getData();
  }

  checkAll(value: boolean): void {
    this.data.forEach(data => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    let arr = [];
    this.data.forEach(a=>{
      if(a.checked  == true){
        arr.push(a)
      }
    })
    this.haveDone.selectedRows = arr;
  }

  searchTable(){
    this.pageNum = 0;          //页数
    var workflowQuery={firstResult:this.pageNum,maxResult:10,requestId:this.haveDone.inputId,nodeType:"1,2",title:this.haveDone.title};
    this.JyExtendService.haveDoneSearch(workflowQuery).subscribe((data)=>{
      this.data = data.content;
      this.haveDone.allBackNum =data.totalCount;
    })
  }

  modalOk() {
    let result = this.haveDone.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  getPageSize(e){
    this.pageSize = e;
      this.getData();
  }
  pageNumber(e){
    this.pageNum = e -1;
    this.getData();
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

}
